import(/* webpackMode: "eager" */ "/vercel/path0/src/app/[locale]/technologies/apis-integration/page.tsx");
